import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { TypedMemo } from '../../../common/types';
import { useShowSMLPricingModal } from '../../../../redux/slices/appInfo/hooks';
import { toggleSMLPricingModal } from '../../../../redux/slices/appInfo/slice';
import { clearCheckoutIntent } from '../../config/checkoutIntent';
import { SMLPricing } from '../SMLPricing';
import { GlobalSMLUpgradeModal } from './GlobalSMLUpgradeModal';

/**
 * The upgrade prompt and the plan picker for a full-screen route (the music video editor, the
 * cover editor). Such a route has no `SMLContainer`, which mounts these two for every other page.
 * Without them, a button that opens the prompt (a locked control, "Remove the watermark", an
 * `M24_LIMIT_*` error) does nothing there, and the prompt opens later on another page. Mount it
 * only on a route of a signed-in user.
 */
const FullScreenUpgradeHostComponent: React.FC = () => {
  const dispatch = useDispatch();
  const isPricingModalOpen = useShowSMLPricingModal();
  const togglePricing = useCallback(() => {
    // The same rule as `SMLContainer`: the checkout intent did its work once the plans page opens.
    clearCheckoutIntent();
    dispatch(toggleSMLPricingModal({ shouldShow: !isPricingModalOpen }));
  }, [dispatch, isPricingModalOpen]);
  return (
    <>
      <SMLPricing isOpen={isPricingModalOpen} toggle={togglePricing} />
      <GlobalSMLUpgradeModal />
    </>
  );
};

export const FullScreenUpgradeHost = TypedMemo(FullScreenUpgradeHostComponent);
